import { capitalizeFirstLetter } from '@mumble/helpers';
export var validationLocales = {
    en: {
        phone: "The field must be a valid phone number",
        email: 'The field must be a valid email address',
        number: "The field must be a number",
        minLength: function (minLength) { return "The field must be longer than or equal to ".concat(minLength, " characters"); },
        maxLength: function (maxLength) { return "The field must be shorter than or equal to ".concat(maxLength, " characters"); },
        exactLength: function (exactLength) { return "The field must be exactly ".concat(exactLength, " characters long"); },
        confirm: function (confirm) { return "".concat(capitalizeFirstLetter(confirm), " field confirmation does not match"); },
        required: "Field required",
        alphabetical: "The field must contain only letters",
        password: "The password must contain at least one number and one special character (Ex. @, #, $, %, ...)",
        custom: function (message) { return message.en; },
    },
    it: {
        phone: "Il campo deve essere un numero di telefono valido",
        number: "Il campo deve essere un numero",
        email: 'Il campo deve essere un indirizzo email valido',
        minLength: function (minLength) { return "Il campo deve essere lungo almeno ".concat(minLength, " caratteri"); },
        maxLength: function (maxLength) { return "Il campo deve essere lungo al massimo ".concat(maxLength, " caratteri"); },
        exactLength: function (exactLength) { return "Il campo deve essere lungo esattamente ".concat(exactLength, " caratteri"); },
        confirm: function (confirm) { return "La conferma del campo ".concat(confirm, " non corrisponde"); },
        required: "Campo obbligatorio",
        alphabetical: "Il campo deve contenere solo lettere",
        password: "La password deve contenere almeno un numero ed un carattere speciale (Es. @, #, $, %, ...)",
        custom: function (message) { return message.it; },
    },
};
